// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorPopup_root__p3pCI","content":"ErrorPopup_content__yxkbJ","icon":"ErrorPopup_icon__RDxPc","text":"ErrorPopup_text__PPOjl","btn":"ErrorPopup_btn__CZo2b"};